import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=811909a2&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=811909a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811909a2",
  null
  
)

export default component.exports